export const LOCAL_STORAGE_KEY = 'direct-deals-last-contact-request-date-';

export const getInitialContactValue = (id: string) => {
  const localValue = localStorage.getItem(LOCAL_STORAGE_KEY + id);

  return localValue || '';
};
